/**
 * Copyright (C) 2026 Jugendstil, SLU - All Rights Reserved
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited. Proprietary and confidential.
 */
import { register } from '../registry.js';

/**
 * Tells the container whether its field has anything in it, so CSS can show the clear button.
 *
 * A data attribute rather than a class, because the state belongs to the container and is derived
 * from the field; nothing else should be able to set it.
 */
export function syncSearch(field: HTMLInputElement): void {
    const container = field.closest<HTMLElement>('[data-wp-search]');
    if (container !== null) {
        container.dataset.filled = String(field.value.length > 0);
    }
}

export function paint(root: ParentNode): void {
    root.querySelectorAll<HTMLInputElement>('[data-wp-search] input').forEach(syncSearch);
}

export function listen(): void {
    document.addEventListener('input', (event) => {
        const target = event.target;
        if (target instanceof HTMLInputElement && target.matches('[data-wp-search] input')) {
            syncSearch(target);
        }
    });

    document.addEventListener('click', (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
            return;
        }

        const button = target.closest('[data-wp-search-clear]');
        if (button === null) {
            return;
        }

        const field = button.closest('[data-wp-search]')?.querySelector('input');
        if (field === null || field === undefined) {
            return;
        }

        field.value = '';
        syncSearch(field);
        field.focus();

        /* The field is cleared programmatically, so nothing else would hear about it. Anything
           listening for input on the search field is listening for the query to change, and it
           just changed. */
        field.dispatchEvent(new Event('input', { bubbles: true }));
    });

    register(paint);
}
